import React, { useCallback, useState } from 'react';

import callApi from '../../../utils/callApi';
import {
  CHECK_USER_EXISTS,
  CREATE_ACCOUNT_API_URL,
} from '../../../constants/apiUrls/apiUrls';

import styles from './css/NewUserSignupV2.module.css';


function NewUserSignupV2(props) {
  const [email, setEmail] = useState('');
  const [emailErrorMessage, setEmailErrorMessage] = useState(undefined);
  const { setShouldShowCheckEmailMessage, user } = props;

  const onInputChange = useCallback(
    (e) => {
      const { value } = e.target;
      setEmail(value);
    },
    [setEmail]
  );

  const isValidEmail = useCallback(() => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const isValid = emailRegex.test(email.toLowerCase());

    return isValid;
  }, [email]);

  const checkUserWithEmailExists = useCallback(() => {
    let URL = CHECK_USER_EXISTS;
    URL = URL.replace('{userEmailID}', `${email}`);
    callApi(URL).
      then((res) => {
        if (res.data.status === 'ALREADY_IN_USE') {
          setEmailErrorMessage('You already have an account please login!');
        } else if (res.data.status === 'NOT_OK') {
          setEmailErrorMessage('Please enter a valid email!');
        } else {
          setEmailErrorMessage(undefined);
        }
      }).
      catch((err) => {
        console.error(err);
      });
  }, [email]);

  const createAccount = () => {
    callApi(CREATE_ACCOUNT_API_URL, 'POST', {}, { email }).
      then((res) => {
        if (res.status === 201) {
          setShouldShowCheckEmailMessage(true);
        }
      }).
      catch((err) => {
        console.error(err);
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail()) {
      setEmailErrorMessage('Please enter a valid email!');

      return;
    }

    if (!checkUserWithEmailExists()) {
      createAccount();
    }
  };

  if (user?.authenticated) {
    return null;
  }

  return (
    <div className={styles.signupContainer}>
      <div className={styles.newUserSignup}>
        <div className={styles.emailTextLeft}>
          <p className={styles.headerText}>
            <b>Sign up for Free</b>
            <div>Free Access To Naked News</div>
          </p>
          <span>
            <h4 className={styles.gray}>
              Enter your email to receive a daily preview. No credit card required.
            </h4>
          </span>
        </div>
        <form action="" className={styles.newUserEmailForm}>
          <div
            className={`${styles.contactForm} ${styles.inputs} flex justify-between`}
          >
            <label htmlFor="email" />
            <input
              id="email"
              placeholder="email@example.com"
              required="required"
              type="text"
              value={email}
              onChange={onInputChange}
            />
          </div>
          <button className={styles.btnCurvedRed} onClick={onSubmit}>
            SIGN UP NOW
          </button>
        </form>
      </div>
      {emailErrorMessage && (
        <p className={styles.redText}>{emailErrorMessage}</p>
      )}
    </div>
  );
}

export default React.memo(NewUserSignupV2);
